<template>
    <popover :show="true" class="site-menu">
        <ul>
            <li v-if="user && user.admin" class="site-menu__item">
                <a class="site-menu__link" href="/settings">
                    <font-awesome-icon class="site-menu__icon" :icon="['fas', 'cog']" />
                    <span class="site-menu__text">Manage Settings</span>
                </a>
            </li>

            <li class="site-menu__item">
                <a class="site-menu__link" href="http://docs.flexaccelerator.com/" target="_blank">
                    <font-awesome-icon class="site-menu__icon" :icon="['fas', 'book']" />
                    <span class="site-menu__text">View Documentation</span>
                </a>
            </li>

            <li class="site-menu__item">
                <a class="site-menu__link" href="#" @click.prevent="logout">
                    <font-awesome-icon class="site-menu__icon" :icon="['fas', 'sign-out-alt']" />
                    <span class="site-menu__text">Log Out</span>
                </a>
            </li>
        </ul>
    </popover>
</template>

<script>
import { mapActions, mapState } from 'vuex';

import Popover from '@/components/page-editor/popover';
import { LOGOUT } from '@/store/types/action-types';

export default {
    components: { Popover },

    computed: {
        ...mapState({
            user: state => state.user.user,
        }),
    },

    methods: {
        ...mapActions({
            logout: LOGOUT,
        }),
    },
};
</script>

<style lang="scss">
.site-menu {
    top: 100%;
    left: 0;
    padding: 0;

    &__item {
        text-align: left;
        color: var(--form-inputColor);
        background-color: var(--form-inputBackgroundColor);
        font-size: 0.875rem;

        &:hover {
            cursor: pointer;
            color: var(--form-inputHoverColor);
            background-color: var(--form-inputHoverBackgroundColor);
        }

        &:not(:first-of-type) {
            border-top: 1px solid var(--form-inputBorderColor);
        }
    }

    &__link {
        display: flex;
        align-items: center;
        padding: 0.75em 1.5em;
    }

    &__icon {
        position: relative;
        top: 1px;
    }

    &__text {
        font-weight: 600;
        margin-left: 0.75em;
    }
}

</style>
